import axios from 'axios';
import {token} from '../services/Authentication'

export default class DatasetDynamicService {

  static save(param) {
        
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset`,
      headers: {              
        "authorization": token(), 
      },
      data: param,
    })
    .then((res) => res, (error) => {throw error})
  }

  static searchById(id) {
      
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/${id}`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static fetchFullById(id) {
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/${id}/full`,
      headers: {
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static async search(param) {
    try {
      const res = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/all`,
        headers: {
          "authorization": token(),
        },
        data: param ? param : {},
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static dashboard() {            
           
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/dahsboard`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static menu() {
    
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/menu`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static deleteById(id) {
                

    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/${id}`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static executeQuery(param, bearerToken) {                        
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/query/execute`,
      headers: {              
        "authorization": bearerToken ? bearerToken : token(), 
      },
      data:param,      
    })
    .then((res) => res, (error) => {throw error})
  }

  static cleanCache(id, bearerToken) {                        
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/cache/clean/${id}`,
      headers: {              
        "authorization": bearerToken ? bearerToken : token(), 
      }       
    })
    .then((res) => res, (error) => {throw error})
  }

  static forOrdered(param) {                        
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/fororder`,
      headers: {              
        "authorization": token(),
      },
      data:param,      
    })
    .then((res) => res, (error) => {throw error})
  }

  static saveNewOrder(param) {                        
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/dataset/order`,
      headers: {              
        "authorization": token(),
      },
      data:param,
    })
    .then((res) => res, (error) => {throw error})
  }

  static searchByTerm(param) {

    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/searchbyterm`,
      headers: {
        "authorization": token(),
        "Content-Type": "application/json"
      },
      data:param,
    })
        .then((res) => res, (error) => {throw error})
  }





}
